<template>
  <div class="flex justify-between h-14">
    <div
      class="w-full text-center pt-2 pb-1 border-r border-white bg-mentalnc text-gray-700 hover:bg-mentalncLight"
    >
      <router-link to="/account">
        <base-icon-text :path="mdiAccount" text="マイページ" />
      </router-link>
    </div>
    <div
      class="w-full text-center pt-2 pb-1 border-x border-white bg-mentalnc text-gray-700 hover:bg-mentalncLight"
    >
      <router-link to="/course">
        <base-icon-text :path="mdiBookOpenPageVariant" :text="t('course.title')" />
      </router-link>
    </div>
    <div
      class="w-full text-center pt-2 pb-1 border-l border-white bg-mentalnc text-gray-700 hover:bg-mentalncLight"
    >
      <router-link to="/seminar">
        <base-icon-text :path="mdiCalendarCheck" text="セミナー" />
      </router-link>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { useI18n } from 'vue-i18n'
import { mdiAccount, mdiBookOpenPageVariant, mdiCalendarCheck } from '@mdi/js'
import BaseIconText from '@/components/BaseIconText.vue'

export default defineComponent({
  components: { BaseIconText },
  setup() {
    const { t } = useI18n()

    return {
      t,
      mdiAccount,
      mdiBookOpenPageVariant,
      mdiCalendarCheck,
    }
  }
})
</script>
